import React from "react";
import { useNavigate } from "react-router-dom";
import { Routes } from "../routes";

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <div className="icon-container">
          <div className="icon-wrapper">
            <span className="lock-icon">🔒</span>
          </div>
        </div>
        
        <h1 className="title">Access Denied</h1>
        
        <p className="description">
          You don't have the required permissions to access this page. 
          Please contact your administrator if you believe this is a mistake.
        </p>

        <div className="action-section">
          <button 
            onClick={() => navigate(Routes.TabNavigator)}
            className="back-button"
          >
            Return to Home
          </button>
          
          <button 
            onClick={() => window.history.back()}
            className="secondary-button"
          >
            Go Back
          </button>
        </div>
      </div>

      <style>{`
        .unauthorized-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          padding: 20px;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .unauthorized-content {
          background: white;
          border-radius: 20px;
          padding: 50px 40px;
          text-align: center;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
          border: 1px solid #e8e8e8;
          max-width: 480px;
          width: 100%;
        }

        .icon-container {
          margin-bottom: 30px;
        }

        .icon-wrapper {
          width: 100px;
          height: 100px;
          margin: 0 auto;
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 25px rgba(255, 107, 107, 0.3);
        }

        .lock-icon {
          font-size: 2.5rem;
          filter: brightness(0) invert(1);
        }

        .title {
          font-size: 2.2rem;
          font-weight: 700;
          color: #2d3748;
          margin: 0 0 16px 0;
          line-height: 1.2;
        }

        .description {
          font-size: 1.1rem;
          color: #718096;
          line-height: 1.6;
          margin: 0 0 40px 0;
          max-width: 400px;
          margin-left: auto;
          margin-right: auto;
        }

        .action-section {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .back-button {
          padding: 14px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 12px;
          border: none;
          background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);
          min-width: 160px;
        }

        .back-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4);
        }

        .back-button:active {
          transform: translateY(0);
        }

        .secondary-button {
          padding: 14px 32px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
          background: white;
          color: #4a5568;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 120px;
        }

        .secondary-button:hover {
          background: #f7fafc;
          border-color: #cbd5e0;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .secondary-button:active {
          transform: translateY(0);
        }

        @media (max-width: 768px) {
          .unauthorized-content {
            padding: 40px 30px;
            margin: 20px;
          }

          .title {
            font-size: 1.8rem;
          }

          .description {
            font-size: 1rem;
          }

          .action-section {
            flex-direction: column;
            align-items: center;
          }

          .back-button,
          .secondary-button {
            width: 100%;
            max-width: 280px;
          }

          .icon-wrapper {
            width: 80px;
            height: 80px;
          }

          .lock-icon {
            font-size: 2rem;
          }
        }

        @media (max-width: 480px) {
          .unauthorized-content {
            padding: 30px 20px;
          }

          .title {
            font-size: 1.6rem;
          }

          .description {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </div>
  );
};